<template>
    <form
        id="onboarding-de"
        class="wrapper wrapper-tab wrapper-tab-8"
        role="form"
        method="post"
        @submit.prevent=""
        novalidate
    >
        <header>
            <span class="new-headline-xlg text-centered">In den letzten zwei Wochen...</span>
        </header>

        <div class="form-input-wrapper has-gradient">
            <div :class="['form-input-wrapper-scroll', {'scrolled': scrollPosition > 0}]" ref="scrollDiv">
                <div class="radio-list-header" ref="scrollHeader">
                    <span v-for="(item, index) in options" :key="index" v-html="item.label"></span>
                </div>

                <div v-for="radio in radioList" :key="radio.name" class="form-input-radio-list">
                    <div class="form-input-radio-list-inner">
                        <span>{{ radio.label }}</span>

                        <div class="radio-list-wrapper form-input-radio form-input-radio--check">
                            <div v-for="(item, index) in options" :key="index" class="radio-wrapper">
                                <input
                                    :id="radio.name + '-' + index"
                                    type="radio"
                                    :name="radio.name"
                                    :value="item.value"
                                    :checked="item.value === radio.value"
                                />
                                <label class="label-static" :for="radio.name + '-' + index" @click="clickOnRadio(radio.name)"></label>
                            </div>
                        </div>
                    </div>

                    <form-input-error
                        v-if="errors && errors[radio.name] && errors[radio.name] !== null"
                        :error="errors[radio.name][0]"
                        :style="'margin-left:' + scrollPosition + 'px'"
                    ></form-input-error>
                </div>
            </div>

            <v-button label="Weiter" size="lg" type="submit" @onClick="onClickButton()" full-width></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                scrollPosition: 0,
                errors: {},
                options: [
                    { label: 'Die ganze Zeit', value: 5 },
                    { label: 'Meistens', value: 4 },
                    { label: 'Etwas mehr als die Hälfte der Zeit', value: 3 },
                    { label: 'Etwas weniger als die Hälfte der Zeit', value: 2 },
                    { label: 'Ab und zu', value: 1 },
                    { label: 'Zu keinem Zeitpunkt', value: 0 }
                ],
                radioList: [
                    {
                        label: '... war ich froh und guter Laune',
                        name: 'happiness',
                        value: (this.data && parseInt(this.data.happiness)) ?? null
                    },
                    {
                        label: '... habe ich mich ruhig und entspannt gefühlt',
                        name: 'relax',
                        value: (this.data && parseInt(this.data.relax)) ?? null
                    },
                    {
                        label: '... habe ich mich energisch und aktiv gefühlt',
                        name: 'energy',
                        value: (this.data && parseInt(this.data.energy)) ?? null
                    },
                    {
                        label: '... habe ich mich beim Aufwachen frisch und ausgeruht gefühlt',
                        name: 'sleep',
                        value: (this.data && parseInt(this.data.sleep)) ?? null
                    },
                    {
                        label: '... war mein Alltag voller Dinge, die mich interessieren',
                        name: 'interest',
                        value: (this.data && parseInt(this.data.interest)) ?? null
                    }
                ]
            }
        },

        mounted() {
            var that = this
            const scroll = this.$refs.scrollDiv
            const scrollHeader = this.$refs.scrollHeader
            var position = scrollHeader.getBoundingClientRect()

            scroll.addEventListener(
                'scroll',
                () => {
                    this.scrollPosition = scroll.scrollLeft
                },
                false
            )

            window.addEventListener('scroll', () => {
                var scrolled = document.documentElement.scrollTop || document.body.scrollTop

                if(scrolled > position.top - scrollHeader.offsetHeight) {
                    scrollHeader.style.top = scrolled - position.top + document.querySelector('.site-header').offsetHeight + 8 + "px"
                    scrollHeader.style.background = '#f8f5ff'
                } else {
                    scrollHeader.style.top = "auto"
                    scrollHeader.style.background = 'none'
                }
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {},

        methods: {
            clickOnRadio(name) {
                if (this.errors[name]) {
                    this.errors[name] = null
                    this.$forceUpdate()
                }
            },
            onClickButton() {
                this.validate()

                if (!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                    this.scrollToError()
                }
            },
            validate() {
                var that = this

                for (let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    if (checkedRadio === undefined) {
                        that.errors[radio.name] = ['Sie müssen mindestens eine Option auswählen.']
                        console.log(that.errors[radio.name][0])
                        this.$forceUpdate()
                    }
                }

                for (let radio of this.radioList) {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    if (checkedRadio !== undefined) {
                        that.isDisabled = false
                        that.errors[radio.name] = null
                    } else {
                        that.isDisabled = true
                        break
                    }
                }
            },
            submit() {
                var data = {
                    uuid: this.uuid,
                    answers: {
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '9' : '7'
                        }
                    }
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    data.answers[radio.name] = { key: radio.name, value: checkedRadio.value.toString() }
                })

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                        this.scrollToError()
                    })
            },
            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError.previousElementSibling).offset().top - 180
                    },
                    800
                )
            },
            saveData() {
                var data = {
                    answers: {}
                }

                this.radioList.forEach((radio, index) => {
                    var radioButtonGroup = document.getElementsByName(radio.name)

                    var checkedRadio = Array.from(radioButtonGroup).find((radio) => radio.checked)

                    data.answers[radio.name] = { key: radio.name, value: checkedRadio ? checkedRadio.value.toString() : null }
                })

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
